import React from 'react';
import cn from 'classnames';
import { Core, Form, Layout, Localization } from 'connex-cds';
import styled from 'styled-components';
import { MaterialComplianceLabel } from './MaterialComplianceLabel';
import { materialComplianceRangeWarning } from '../style';

const { Column, Row, Container } = Layout;

const Styled = styled.div`
  .container .spinner {
    margin-top: unset !important;
  }

  .material-compliance-not-found {
    text-align: center;
  }

  div[data-testid='consistenceValue-form-field'] label.label,
  div[data-testid='airContentValue-form-field'] label.label,
  div[data-testid='airTempValue-form-field'] label.label,
  div[data-testid='concreteTempValue-form-field'] label.label,
  div[data-testid='cylinderNumber-form-field'] label.label {
    display: none;
  }

  span.translate-label {
    text-transform: capitalize;
    font-size: 16px;
    font-weight: 500;
  }

  ${materialComplianceRangeWarning}
`;

export const MaterialComplianceMobile = ({
  loadingMaterialCompliance,
  air,
  consistence,
  airTemp,
  concreteTemp,
  cylinder,
  consistenceDisabled,
  airDisabled,
  materialComplianceNotFound,
  ranges = {},
}) => {
  const {
    Components: {
      ConsistenceValue,
      ConsistenceIsCompliant,
      AirContentValue,
      AirContentIsCompliant,
      DateTest,
      AirTempValue,
      ConcreteTempValue,
      CylinderNumber,
      AdditionalInfo,
    },
  } = Form.useFormContext();

  return (
    <Styled className={cn('material-compliance')}>
      <Container>
        <Column>
          <Core.Spinner spin={loadingMaterialCompliance}>
            {consistence && (
              <>
                <Row>
                  <Column>
                    <MaterialComplianceLabel
                      materialCompliance={consistence}
                      concreteClass={ranges?.consistence?.concreteClass}
                      outOfRange={ranges?.consistence?.outOfRange}
                    />
                    <ConsistenceValue uomCode={consistence?.uomCode} />
                  </Column>
                </Row>
                {consistence?.checkCompliance && (
                  <Row style={{ padding: '0px 0px 20px 0px' }}>
                    <Column>
                      <ConsistenceIsCompliant disabled={consistenceDisabled} />
                    </Column>
                  </Row>
                )}
              </>
            )}
            {air && (
              <>
                <Row>
                  <Column>
                    <MaterialComplianceLabel
                      materialCompliance={air}
                      concreteClass={ranges?.air?.concreteClass}
                      outOfRange={ranges?.air?.outOfRange}
                    />
                    <AirContentValue uomCode={air?.uomCode} />
                  </Column>
                </Row>
                {air?.checkCompliance && (
                  <Row style={{ padding: '0px 0px 20px 0px' }}>
                    <Column>
                      <AirContentIsCompliant disabled={airDisabled} />
                    </Column>
                  </Row>
                )}
              </>
            )}
            {airTemp && (
              <Row>
                <Column>
                  <MaterialComplianceLabel materialCompliance={airTemp} />
                  <AirTempValue uomCode={airTemp?.uomCode} />
                </Column>
              </Row>
            )}
            {concreteTemp && (
              <Row>
                <Column>
                  <MaterialComplianceLabel
                    materialCompliance={concreteTemp}
                    concreteClass={ranges?.concreteTemp?.concreteClass}
                    outOfRange={ranges?.concreteTemp?.outOfRange}
                  />
                  <ConcreteTempValue uomCode={concreteTemp?.uomCode} />
                </Column>
              </Row>
            )}
            {cylinder && (
              <Row>
                <Column>
                  <MaterialComplianceLabel materialCompliance={cylinder} />
                  <CylinderNumber uomCode={cylinder?.uomCode} />
                </Column>
              </Row>
            )}
            {[air, consistence, airTemp, concreteTemp, cylinder].some(Boolean) && (
              <>
                <Row>
                  <Column>
                    <AdditionalInfo rows={3} validationText={false} />
                  </Column>
                </Row>

                <Row>
                  <Column>
                    <DateTest />
                  </Column>
                </Row>
              </>
            )}

            {materialComplianceNotFound && (
              <Row>
                <Column className="material-compliance-not-found">
                  <Localization.Translate
                    stringId="materialCompliance_notFound"
                    data-testid="materialCompliance_notFound"
                  />
                </Column>
              </Row>
            )}
          </Core.Spinner>
        </Column>
      </Container>
    </Styled>
  );
};
